<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('setting') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('change_language')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="lang" @change="changeLang">
                                        <option value="en">{{$t('lang_english')}}</option>
                                        <option value="kh">{{$t('lang_khmer')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function(){
        return {
            lang: 'en'
        }
    },
    created: function(){
        this.getUserSetting();
    },
    methods: {
        changeLang(){
            let loading = this.$loading.show();
            this.$api().post('user/change-language', { Language: this.lang }).then(res => {
                if(this.$isValid(res)){
                    this.$i18n.locale = this.lang;
                }
            }).finally(() => loading.hide());
        },
        getUserSetting(){
            let loading = this.$loading.show();
            this.$api().post('user/setting').then(res => {
                if(this.$isValid(res)){
                    this.lang = res.data.Json.Lang;
                }
            }).finally(() => loading.hide());
        }
    }
}
</script>